import React from 'react'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { Stack, Divider, IconButton, FormGroup, FormControlLabel, Switch, Tooltip, } from '@mui/material';
import SbcCommon from './SbcCommon';
import MultiLangDialogAndSingleDisplayIpt from './MultiLangDialogAndSingleDisplayIpt';
import Iconify from '../../common/iconify/Iconify';
import { ICONIFY } from '../../../Constants/iconify';
import SbcOptions from './SbcOptions';
import SbcWrapper from './SbcWrapper';

// sidebar panel for dropdown
export default function SbcDropdown({
    data,
    handleIptChange,
    handleOptions,
    handleSwitchChange,
    handleSelectChange,
    handleMultiIptChange,
    handleDragOptions
}) {
    return (
        <SbcWrapper>
            <SbcCommon
                data={data}
                handleIptChange={handleIptChange}
                handleMultiIptChange={handleMultiIptChange}
                handleSwitchChange={handleSwitchChange}
                handleSelectChange={handleSelectChange}
            />
            <SbcOptions
                data={data}
                handleMultiIptChange={handleMultiIptChange}
                handleSwitchChange={handleSwitchChange}
                handleSelectChange={handleSelectChange}
                handleOptions={handleOptions}
                handleDragOptions={handleDragOptions}
            />
        </SbcWrapper>
    )
}
